import fetch from 'node-fetch';
import qs from 'query-string';
import Promise from 'bluebird';
import _ from 'lodash';
import config from '../config';
import { cachePromise } from '../util/decorators';
import sportBackend from './sportBackend';

const keyMapping = {
  programType: 'data.tags.programType.slug',
};

const { PAPI_URL } = config;
const { PAPI_PARTNER_URL } = config;
const REQUEST_BATCH_TIME = 15 * 1000;
const TIMEOUT = 5000;
const DEFAULT_TAGS = {
  type: '',
};
//const PAPI_TEST = 'http://18.197.119.212';
// Inject MSP API Headers with webpack. The headers are diffrent for client/server.
// Server headers should not be readable in the client bundle.
const MSP_API_HEADERS = __WEBPACK_INJECTED_MSP_HEADERS__; // eslint-disable-line no-undef

function fetchFromMspAPI(url) {
	console.log(`fetchFromMspAPI:  ` + url);
  return Promise.resolve(fetch(url, { headers: MSP_API_HEADERS, timeout: TIMEOUT }));
}

function getContentContainerFromResponse(response) {
  return response.json()
    .then(res => {
      // /posts || /posts/manual-lists
      if (res.embedded && res.embedded.posts) {
        return res.embedded.posts.map(item => ({ ...item.data, ...item.embedded }));
      }

      // /posts/:id
      return { ...res.data, ...res.embedded };
    })
    .catch(err => {
      /* eslint no-unused-expressions: [0, { "allowShortCircuit": true }] */
      window.console && console.error('Failed to fetch from API:', err);
      return;
    });
}

const api = {
  @cachePromise(REQUEST_BATCH_TIME)
  getTagValues(tag, country) {
    const url = `${PAPI_URL}/viasport/${country}/tag-values-for/${tag}`;
    return fetchFromMspAPI(url).then(res => res.json());
  },

  @cachePromise(REQUEST_BATCH_TIME)
  getContentContainer(slug, country, search) {//id, country, search
	//let url = `${PAPI_URL}/viasport/${country}/slugs/${slug}`;
	let url = `${PAPI_URL}/viasport/${country}/slugs/${slug}/post`;	
	//let url = `${PAPI_URL}/viasport/${country}/posts/${id}`;
	//console.log(`fetchFromMspAPI IDID:  ` + url);
    if (search && search.previewHash) url += `?previewHash=${search.previewHash}`;

    return fetchFromMspAPI(url).then(getContentContainerFromResponse);
  },

  @cachePromise(REQUEST_BATCH_TIME)
  getContentContainersWithExtendedEvents(params, tags, sort, limit, offset, country, excludeParams, excludedInResponse, language) {
    return api.getContentContainers(params, tags, sort, limit, offset, country, excludeParams, excludedInResponse)
      .then(async contentContainers => {
        const eventIds = _.compact(_.map(contentContainers, 'tags.events[0]'));
        const competitionIds = _.compact(_.map(contentContainers, 'tags.competitions[0].id'));
        const events = await sportBackend.getEvents(_.uniq(eventIds), _.uniq(competitionIds), language);

        return _.map(contentContainers, container =>
          _.set(container, 'extendedEvent', _.find(events, { id: _.get(container, 'tags.events[0]') }))
        );
      });
  },

  @cachePromise(REQUEST_BATCH_TIME)
  getContentContainerById(params, country) {
    return fetchFromMspAPI(`${PAPI_URL}/viasport/${country}/postbyid/${params.postId}`)
      .then(getContentContainerFromResponse)
      .then(res => [res]);
  },
  @cachePromise(REQUEST_BATCH_TIME)
  getRssPartnerContentContainers(params = {}, tags = {}, sort='popular', limit = 10, offset = 0, country, partner, exclude, excludedInResponse) {
    _.defaults(tags, DEFAULT_TAGS);
    let query = qs.stringify({
      sort: (sort || 'popular').toLowerCase(),
      limit,
      offset,
    });

    if (tags.q) {
      const q = {};

      const tagObjects = {...params, ...tags.q};
      _.forEach(tagObjects, (tagObject, key) => {
        const actualKey = keyMapping[key] || key;

        if (!q.and) q.and = [];
        if (typeof tagObject === 'object') {
          if (!q.or) q.or = [];
          tagObject.forEach((tag) => { // eslint-disable-line no-loop-func
            q.or.push({ [actualKey]: tag });
          });
        } else {
          q.and.push({ [actualKey]: tagObjects[key] } );
        }
      });

      if (exclude && exclude.length) {
        q.not = exclude;
      }

      query += `&q=${encodeURIComponent(JSON.stringify(q))}`;
    }

    if (excludedInResponse) {
      query += `&exclude=${excludedInResponse.join(',')}`;
    }
    console.log(`rsslistfeed:  ` + `${PAPI_PARTNER_URL}/viasport/${country}/rss?partner=${partner}&${query}`);
    return fetchFromMspAPI(`${PAPI_PARTNER_URL}/viasport/${country}/rss?partner=${partner}&${query}`)
      .then(getContentContainerFromResponse);
  },
  
  @cachePromise(REQUEST_BATCH_TIME)
  getContentContainerRSSFEED(country, tagName) {
	  return fetchFromMspAPI(`http://sport.nentgroup.dk/tv3sport/${country}/${tagName}`)
      .then(getContentContainerFromResponse);
  },
  
  @cachePromise(REQUEST_BATCH_TIME)
  getRssContentContainers(params = {}, tags = {}, sort='popular', limit = 10, offset = 0, country, partner, exclude, excludedInResponse) {
    _.defaults(tags, DEFAULT_TAGS);
    let query = qs.stringify({
      sort: (sort || 'popular').toLowerCase(),
      limit,
      offset,
    });

    if (tags.q) {
      const q = {};

      const tagObjects = {...params, ...tags.q};
      _.forEach(tagObjects, (tagObject, key) => {
        const actualKey = keyMapping[key] || key;

        if (!q.and) q.and = [];
        if (typeof tagObject === 'object') {
          if (!q.or) q.or = [];
          tagObject.forEach((tag) => { // eslint-disable-line no-loop-func
            q.or.push({ [actualKey]: tag });
          });
        } else {
          q.and.push({ [actualKey]: tagObjects[key] } );
        }
      });

      if (exclude && exclude.length) {
        q.not = exclude;
      }

      query += `&q=${encodeURIComponent(JSON.stringify(q))}`;
    }

    if (excludedInResponse) {
      query += `&exclude=${excludedInResponse.join(',')}`;
    }
    //console.log(`rsslistfeed:  ` + `${PAPI_URL}/viasport/${country}/posts?${query}`);
    //return fetchFromMspAPI(`${ECS_URL}/viasport/${country}/posts?${query}`)
    return fetchFromMspAPI(`${PAPI_URL}/viasport/${country}/rssposts?partner=${partner}&${query}`)
      .then(getContentContainerFromResponse);
  },
  @cachePromise(REQUEST_BATCH_TIME)
  getContentContainers(params = {}, tags = {}, sort, limit = 10, offset = 0, country, exclude, excludedInResponse) {
    _.defaults(tags, DEFAULT_TAGS);
    let query = qs.stringify({
      sort: (sort || '').toLowerCase(),
      limit,
      offset,
    });

    if (tags.q) {
      const q = {};

      const tagObjects = {...params, ...tags.q};
      _.forEach(tagObjects, (tagObject, key) => {
        const actualKey = keyMapping[key] || key;

        if (!q.and) q.and = [];
        if (typeof tagObject === 'object') {
          if (!q.or) q.or = [];
          tagObject.forEach((tag) => { // eslint-disable-line no-loop-func
            q.or.push({ [actualKey]: tag });
          });
        } else {
          q.and.push({ [actualKey]: tagObjects[key] } );
        }
      });

      if (exclude && exclude.length) {
        q.not = exclude;
      }

      query += `&q=${encodeURIComponent(JSON.stringify(q))}`;
    }

    if (excludedInResponse) {
      query += `&exclude=${excludedInResponse.join(',')}`;
    }
    //console.log(`rssfeed:  ` + `${PAPI_URL}/viasport/${country}/posts?${query}`);
    //return fetchFromMspAPI(`${ECS_URL}/viasport/${country}/posts?${query}`)
    return fetchFromMspAPI(`${PAPI_URL}/viasport/${country}/posts?${query}`)
      .then(getContentContainerFromResponse);
  },
  
  @cachePromise(REQUEST_BATCH_TIME)
  getContentContainers_live(params = {}, tags = {}, sort, limit = 10, offset = 0, country, exclude, excludedInResponse) {
    _.defaults(tags, DEFAULT_TAGS);
    let query = qs.stringify({
      sort: (sort || '').toLowerCase(),
      limit,
      offset,
    });

    if (tags.q) {
      const q = {};

      const tagObjects = {...params, ...tags.q};
      _.forEach(tagObjects, (tagObject, key) => {
        const actualKey = keyMapping[key] || key;

        if (!q.and) q.and = [];
        if (typeof tagObject === 'object') {
          if (!q.or) q.or = [];
          tagObject.forEach((tag) => { // eslint-disable-line no-loop-func
            q.or.push({ [actualKey]: tag });
          });
        } else {
          q.and.push({ [actualKey]: tagObjects[key] } );
        }
      });

      if (exclude && exclude.length) {
        q.not = exclude;
      }

      query += `&q=${encodeURIComponent(JSON.stringify(q))}`;
    }

    if (excludedInResponse) {
      query += `&exclude=${excludedInResponse.join(',')}`;
    }
    //console.log(`rssfeed:  ` + `${PAPI_URL}/viasport/${country}/posts?${query}`);
    //return fetchFromMspAPI(`${ECS_URL}/viasport/${country}/posts?${query}`)
    return fetchFromMspAPI(`${PAPI_URL}/viasport/${country}/posts_live?${query}`)
      .then(getContentContainerFromResponse);
  },
  @cachePromise(REQUEST_BATCH_TIME)
  getContentContainers_live1(tags = {}, sort, limit = 10, offset = 0, country='dk') {
    _.defaults(tags, DEFAULT_TAGS);
    let query = qs.stringify({
      sort: (sort || '').toLowerCase(),
      limit,
      offset,
    });
    //console.log(`getContentContainers_live:  ` + `${PAPI_URL}/viasport/${country}/posts_live?${query}`);
    return fetchFromMspAPI(`${PAPI_URL}/viasport/${country}/posts_live?${query}`)
      .then(getContentContainerFromResponse);
  },
  @cachePromise(REQUEST_BATCH_TIME)
  getRelatedContentContainers(slug, relatedTagName, sort, limit = 5, offset = 0, country) {
    let relatedTagNames = '&relatedTagName=';

    relatedTagNames += typeof relatedTagName === 'string' ? relatedTagName : relatedTagName.join(',');
    //return fetchFromMspAPI(`${ECS_URL}/viasport/${country}/posts/${slug}/related-posts?limit=${limit}&offset=${offset}${relatedTagNames}`)
    
    	    
    //return fetchFromMspAPI(`${PAPI_URL}/viasport/${country}/relatedposts/${id}/${limit}/${offset}`)
    
    //return fetchFromMspAPI(`${PAPI_URL}/viasport/${country}/relatedposts/${id}/${limit}/${offset}`)
    //return fetchFromMspAPI(`${PAPI_URL}/viasport/${country}/slugs-posts/${slug}/related-posts`)
    //return fetchFromMspAPI(`${PAPI_URL}/viasport/${country}/posts/${slug}/related-posts?limit=${limit}&offset=${offset}${relatedTagNames}`)
    //.then(getContentContainerFromResponse);
    return fetchFromMspAPI(`https://viasport-gw.mtg-api.com/editorial-content/viasport/dk/posts?limit=100&offset=0&sort=latest&q=%7B%22and%22%3A%5B%7B%22contents%22%3A%22video%22%7D%5D%7D&exclude=data.text.body,data.preamble,embedded.relatedArticles,embedded.authors,data.tags.participants`).then(getContentContainerFromResponse);
    
  },

  @cachePromise(REQUEST_BATCH_TIME)
  getManualList(id, limit, country='dk') {
    if (!id) return Promise.resolve([]);
    //OK const manualListsUrl = `${PAPI_URL}/viasport/${country}/sport/${id}/${limit}`;
    //const manualListsUrl = `${PAPI_URL}/viasport/${country}/manual-lists/${id}/${limit}`;
    const manualListsUrl = `${PAPI_URL}/viasport/${country}/manual-lists/${id}/posts?limit=${limit}`;

    return fetchFromMspAPI(manualListsUrl)
      .then(response => !response.ok ? [] : getContentContainerFromResponse(response));
  },

  @cachePromise(REQUEST_BATCH_TIME)
  getSelectedTemplates() {

	let json = Promise.resolve([
	{"template":"dk.golfpage.sport-auto-news","page":"dk.golfPage"},
	{"template":"dk.footballpage.triple-news-competition-name","page":"dk.footballPage"},
	{"template":"dk.startpage.triple-news-competition-name","page":"dk.startpage"},
	{"template":"dk.icehockeypage.sport-small-news","page":"dk.iceHockeyPage"},
	{"template":"dk.broadcastarea.two","page":"dk.broadcastarea"},
	{"template":"dk.motorpage.sport-auto-news","page":"dk.motorPage"}
	]);
  	 return json;
  },

  @cachePromise(REQUEST_BATCH_TIME)
  getTextPageContent(type, country) {
    return new Promise(resolve =>
      require.ensure([], require => resolve([require(`../../assets/textpages/${country}/${type}.json`)]), 'text-pages')
    );
  },

  @cachePromise(REQUEST_BATCH_TIME)
  getSearchResults(search, limit = 10, offset = 0, country) {
    if (!search.q) return Promise.resolve({ embedded: { posts: [] }, data: { total: 0 } });

    const params = {
      text: search.q,
      limit,
      offset,
      exclude: 'data.text.body',
    };

    // TODO Should be generalized once we add more options for user search query
    if (search.videoType) params.q = `{"and":[{"data.tags.videoTypes": "${search.videoType}"}]}`;

    const query = qs.stringify(params);
    //console.log(`getSearchResults:  ` + query);
    return fetchFromMspAPI(`${PAPI_URL}/viasport/${country}/posts?${query}`)
    //return fetchFromMspAPI(`${PAPI_URL}/viasport/${country}/search?${query}`)
      .then(res => res.json());
  },

  postVote(pollId, choiceId, country) {
    const url = `${PAPI_URL}/viasport/${country}/polls/${pollId}/votes/${choiceId}`;
    //console.log(`postVote:  ` + url);
    return Promise.resolve(fetch(url, { method: 'POST', timeout: TIMEOUT }))
      .then(res => res.json());
  },
};

export default api;



// WEBPACK FOOTER //
// ./src/service/viasportBackend.js